<template>
  <v-container fluid class="property-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-property`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-home-city</v-icon>
            Property
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-units`" >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Units
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>

          <v-tab-item
            :value="'tab-property'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Property</p>
                      <v-text-field
                        class="mb-4"
                        type="Number"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'propertyrank')"
                        v-bind:value="initvalue.propertyrank"
                        placeholder="Property Rank"
                        persistent-hint
                        single-line hint="Enter the property rank">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'propertycode')"
                        v-bind:value="initvalue.propertycode"
                        placeholder="Property Code"
                        persistent-hint
                        single-line hint="Enter the property code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'propertyname')"
                        v-bind:value="initvalue.propertyname"
                        placeholder="Property Name"
                        persistent-hint
                        single-line hint="Enter the property name">
                      </v-text-field>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'propertystatus')"
                          v-bind:label="initvalue.propertystatus"
                          v-model="initvalue.propertystatus"
                          value="Active"
                      ></v-switch>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items=property_types
                        :value="initvalue.propertytype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'propertytype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the property type">
                      </v-select>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'propertyinfo')"
                        v-bind:value="initvalue.propertyinfo"
                        placeholder="Property Info"
                        persistent-hint
                        single-line hint="Enter the property info">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'geolocation')"
                        v-bind:value="initvalue.geolocation"
                        placeholder="Geolocation"
                        persistent-hint
                        single-line hint="Enter the geolocation">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-textarea
                        outlined
                        v-bind:value="initvalue.propertyaddress"
                        v-on:change="updateChangedValue($event, 'propertyaddress')"
                        rows="3"
                        label="Property Address"
                        hint="please enter the property address"
                      ></v-textarea>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'propertyphone')"
                        v-bind:value="initvalue.propertyphone"
                        placeholder="Property Phone"
                        persistent-hint
                        single-line hint="Enter the property phone">
                      </v-text-field>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="9">
                    <div class="d-flex justify-center">
                      <v-btn
                          to="/property/list"
                          replace
                          outlined
                          color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                        <v-btn
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="editProperty()">
                          Save
                        </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-units'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col md="6">
                    <p class="text-h5">Units</p>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" lg="6" class="d-flex flex-end justify-md-end overflow-auto" align="right">
                    <v-btn
                      class="button-shadow mr-1"
                      color="success"
                      @click="isAddUnit=true; new_unit={}">
                      Add
                    </v-btn>
                    <v-btn
                      class="button-shadow mr-1"
                        to="/property/list"
                        replace
                        color="primary"
                      >
                        Done
                    </v-btn>
                  </v-col>
                  </v-row>
                  <v-data-table
                    sort-by="transrank"
                    :headers="header_items"
                    :items="units"
                    :items-per-page="100"
                    :footer-props="footer"
                    class="elevation-0"
                  >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteUnit" width="500">
                            <v-card>
                              <v-card-title> Delete this Unit? </v-card-title>
                              <v-card-text>
                                {{ delete_unit.unitname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteUnit = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteUnit(delete_unit)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.itemimage="{ item }">
                          <v-img
                            v-bind:lazy-src="item.itemimage"
                            min-width="50"
                            max-width="100"
                            v-bind:src="item.itemimage"
                          ></v-img>
                        </template>
                        <template v-slot:item.unittype="{ item }">
                          {{ item.unitname }} {{ item.unittype }}
                        </template>
                        <template v-slot:item.area_size="{ item }">
                          {{ item.area_size }} {{ item.area_unit }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editUnitDialog(item)"
                          >
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteUnitDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/property/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div>
      <v-dialog
        v-model="isAddUnit"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Unit</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="new_unit.unitnum"
                    class="mb-4"
                    dense
                    placeholder="Unit Num"
                    persistent-hint
                    single-line hint="Unit Num">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="new_unit.unitname"
                    class="mb-4"
                    dense
                    placeholder="Unit Name"
                    persistent-hint
                    single-line hint="Unit Name">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="['Apartment', 'Condo', 'Office', ]"
                    v-model="new_unit.unittype"
                    dense
                    placeholder="Type"
                    persistent-hint
                    single-line hint="Type">
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="['Furnished', 'Partially Furnished', 'Not Furnished' ]"
                    v-model="new_unit.furnish_type"
                    dense
                    placeholder="Furnishing"
                    persistent-hint
                    single-line hint="Furnishing">
                  </v-select>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="new_unit.year_built"
                    class="mb-4"
                    dense
                    placeholder="Year"
                    persistent-hint
                    single-line hint="Year">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="new_unit.num_room"
                    class="mb-4"
                    dense
                    placeholder="Room"
                    persistent-hint
                    single-line hint="Room">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="new_unit.num_bedroom"
                    class="mb-4"
                    dense
                    placeholder="Bed"
                    persistent-hint
                    single-line hint="Bed">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="new_unit.num_bathroom"
                    class="mb-4"
                    dense
                    placeholder="Bath"
                    persistent-hint
                    single-line hint="Bath">
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="new_unit.area_size"
                    class="mb-4"
                    dense
                    placeholder="Area"
                    persistent-hint
                    single-line hint="Area">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-select
                    class="mb-4"
                    :items="['Sqft', 'Sqm' ]"
                    v-model="new_unit.area_unit"
                    dense
                    placeholder="Unit"
                    persistent-hint
                    single-line hint="Unit">
                  </v-select>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="new_unit.unitdesc"
                    rows=5
                    label="Description"
                    hint="please enter description"
                  ></v-textarea>
                </v-col>
                
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddUnit=false; new_unit={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="insertUnit"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditUnit"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Unit</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="edit_unit.unitnum"
                    class="mb-4"
                    dense
                    placeholder="Unit Num"
                    persistent-hint
                    single-line hint="Unit Num">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="edit_unit.unitname"
                    class="mb-4"
                    dense
                    placeholder="Unit Name"
                    persistent-hint
                    single-line hint="Unit Name">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="['Apartment', 'Condo', 'Office', ]"
                    v-model="edit_unit.unittype"
                    dense
                    placeholder="Type"
                    persistent-hint
                    single-line hint="Type">
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="furnish_types"
                    v-model="edit_unit.furnish_type"
                    dense
                    placeholder="Furnishing"
                    persistent-hint
                    single-line hint="Furnishing">
                  </v-select>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="edit_unit.year_built"
                    class="mb-4"
                    dense
                    placeholder="Year"
                    persistent-hint
                    single-line hint="Year">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="edit_unit.num_room"
                    class="mb-4"
                    dense
                    placeholder="Room"
                    persistent-hint
                    single-line hint="Room">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="edit_unit.num_bedroom"
                    class="mb-4"
                    dense
                    placeholder="Bed"
                    persistent-hint
                    single-line hint="Bed">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="edit_unit.num_bathroom"
                    class="mb-4"
                    dense
                    placeholder="Bath"
                    persistent-hint
                    single-line hint="Bath">
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="edit_unit.area_size"
                    class="mb-4"
                    dense
                    placeholder="Area"
                    persistent-hint
                    single-line hint="Area">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-select
                    class="mb-4"
                    :items="['Sqft', 'Sqm' ]"
                    v-model="edit_unit.area_unit"
                    dense
                    placeholder="Unit"
                    persistent-hint
                    single-line hint="Unit">
                  </v-select>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="edit_unit.unitdesc"
                    rows=5
                    label="Description"
                    hint="please enter description"
                  ></v-textarea>
                </v-col>
                
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditUnit=false; edit_unit={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateUnit"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import router from '@/Routes';
import {mapActions, mapState} from "vuex";

export default {
  data () {
    return {
      filename: null,
      imageurl: undefined,
      isAddUnit: false,
      isEditUnit: false,
      isDeleteUnit: false,
      errorindex: undefined,
      change_property: {},
      photo: {},
      initvalue: {},
      upload: {},
      new_unit: {},
      delete_unit: {},
      edit_unit: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      images: [],
      units: [],
      furnish_types: ['Fully Furnished', 'Partially Furnished', 'Not Furnished' ],
      property_types: ['Apartment', 'Office', 'Medical Office', 'Retail', 'Industrial', 'Investment'],
      header_items: [
        { text: 'Unit Num', value: 'unitnum', width: '8%'},
        { text: 'Type', value: 'unittype', width: '8%'},
        { text: 'Area', value: 'area_size', width: '8%'},
        { text: "Actions", value: "actions", sortable: false, width: '10%' },
      ],
    }
  },
  computed: {
    ...mapState('Property', ['isReceiving'])
  },
  methods: {
    ...mapActions('Property', [
      'getPropertyRequest', 
      'deletePropertyUnitRequest',
      'insertPropertyUnitRequest', 
      'updatePropertyRequest','updatePropertyImageRequest', 'updatePropertyUnitRequest'
  ]),
    checkUnit(){
      if(!this.new_unit.unitnum){
        this.error = 'unitnum';
        return false;
      }
      if(!this.new_unit.unitname){
        this.error = 'unitname';
        return false;
      }
      if(!this.new_unit.unittype){
        this.error = 'unittype';
        return false;
      }
      this.error = null;
      return true;
    },
    deleteUnitDialog(item) {
      this.isDeleteUnit = true;
      this.delete_unit = { _id: item._id, unitname: item.unitname };
    },
    async deleteUnit(payload) {
      this.isDeleteUnit = false;
      let response = await this.deletePropertyUnitRequest(payload);
      let index = this.units.findIndex((trans) => trans._id == response._id);
      this.units.splice(index, 1);
      this.getPropertyRequest(this.initvalue._id);
    },
    async editProperty() {
      this.change_property._id = this.initvalue._id;
      await this.updatePropertyRequest(this.change_property);
      router.push('/property/list');
    },
    editUnitDialog(item) {
      this.edit_unit = Object.assign({}, item);
      this.isEditUnit = true;
    },
    async updateUnit() {
      this.isEditUnit = false;
      let response = await this.updatePropertyUnitRequest(this.edit_unit);
      let index = this.units.findIndex((x) => x._id == response._id);
      this.units.splice(index, 1, response);
      this.getPropertyRequest(this.initvalue._id);
      this.edit_unit = {};
    },
    async editPhoto() {
      this.photo._id = this.initvalue._id;
      console.log(this.photo)
      await this.updatePropertyImageRequest(this.photo);
      router.push('/property/list');
    },
    async insertUnit() {
      if(!this.checkUnit()) return;
      this.isAddUnit = false;
      let payload = Object.assign({propertyid: this.initvalue._id}, this.new_unit);
      let response = await this.insertPropertyUnitRequest(payload);
      this.units.push(response);
      
    },
    updateChangedValue(value, field){
      this.change_property[field] = value;
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.photo.propertyimage = file;
      this.photo.imagename = file.name;
      this.createImage(file);
    },
    onUploadChange(file) {
      if (!file) {return;}
      this.upload.propertyimage = file;
      this.upload.imagename = file.name;
      console.log(this.upload);
    },
  },

  created () {
    this.initvalue = this.$route.params;
    this.imageurl = this.initvalue.propertyimage;
    this.units = this.initvalue.propertyunits;
    if(!this.initvalue._id) this.$router.push({ name: 'PropertyList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
